<template>
  <label :class="['spl-label', {'spl-label-inline': inline}, {'spl-label-dark': dark}]"><slot /></label>
</template>

<script>
export default {
  name: 'FormLabel',
  props: [
    'dark',
    'inline',
    'label'
  ]
}
</script>

<style lang="scss">
    @import '../../variables.scss';

    .spl-label {
        color: $darkYellow;
        display: block;
        font-family: $mono;
        font-size: 9px;
        font-weight: 700;
        line-height: 12px;
        letter-spacing: 1px;
        margin-bottom: 10px;
        min-height: 12px;
        text-transform: uppercase;

        &-dark {
            color: $mainInputColor;
        }
        &-inline {
            display: inline-block;
            margin-right: 10px;
        }
        @include mobile() {
            font-size: 14px;
        }
    }
</style>
